import { useRef } from "react";

//#region src/hooks/useRefCurrent.ts
function useRefCurrent(value) {
	const ref = useRef(value);
	ref.current = value;
	return ref;
}

//#endregion
export { useRefCurrent };